export default "__VITE_PUBLIC_ASSET__8b7d7e84__"